// Testo descrittivo della scheda usato, generato in modo deterministico dai soli dati tecnici
// (nessun fatto inventato). Varianti di apertura scelte in base al vehicleid per evitare testi identici.
import { km as fmtKm, cvDi } from "@/components/UsatoCard";

const eur = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
const mese = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { month: "long", year: "numeric" }) : null);
const ok = (s) => s && !/generic/i.test(s);
const bello = (s) => s.toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());

const OPTIONAL_TOP = /navigat|climatizz|cerchi in lega|sensori|telecamera|retrocamera|cruise|led|carplay|android|keyless|tetto|pelle|riscaldat|park|adaptive|lane|head-up|wireless|hi-fi|harman|bose|360/i;

const ALIM = {
  Benzina: "motore a benzina",
  Diesel: "motore diesel",
  Hybrid: "motorizzazione ibrida",
  "Plug-in Hybrid": "motorizzazione ibrida plug-in ricaricabile",
  Elettrico: "motore 100% elettrico",
};

const APERTURE = [
  (n, t) => `${n} disponibile in noleggio lungo termine usato con il programma SecondLife di XMOVE: ${t} che ha concluso il primo ciclo di noleggio ed è stato selezionato per rientrare nel circuito NLT Re-Use.`,
  (n, t) => `Questa ${n} è ${t} NLT Re-Use: ha completato un primo ciclo di noleggio a lungo termine, è stata selezionata tra le migliori ed è di nuovo disponibile con la formula SecondLife.`,
  (n, t) => `${n} disponibile in Noleggio Lungo Termine SecondLife: ${t} con storico di noleggio completo, controllato e rimesso a disposizione da XMOVE con le stesse garanzie del lungo termine.`,
];

export const descrizioneUsato = (a) => {
  const nome = `${a.marca} ${a.modello}`;
  const tipo = a.tipo_veicolo === "commerciale" ? "un veicolo commerciale" : a.tipo_veicolo === "moto" ? "uno scooter" : "un'auto";
  const idx = Number(String(a.vehicleid).replace(/\D/g, "").slice(-2) || 0) % APERTURE.length;
  const frasi = [APERTURE[idx](nome, tipo)];

  const tec = [];
  if (a.versione) tec.push(`La versione è ${a.versione.replace(/\s*\(.*?\)\s*/g, " ").replace(/\s+FP$/, "").trim()}`);
  const motore = [ALIM[a.alimentazione], cvDi(a) ? `${cvDi(a)} CV` : null].filter(Boolean).join(" da ");
  if (motore) tec.push(`${tec.length ? "con" : "Monta un"} ${motore}`);
  if (a.cambio) tec.push(`${tec.length ? "e" : "Ha un"} cambio ${a.cambio.toLowerCase()}`);
  if (tec.length) frasi.push(tec.join(" ") + ".");

  const uso = [];
  if (a.immatricolazione) uso.push(`Immatricolata ${/^[aeiou]/i.test(mese(a.immatricolazione)) ? "ad" : "a"} ${mese(a.immatricolazione)}`);
  if (a.km) uso.push(`${uso.length ? "ha percorso" : "Ha percorso"} ${fmtKm(a.km)}${a.data_km ? ` (rilevati il ${new Date(a.data_km).toLocaleDateString("it-IT")})` : ""}`);
  if (uso.length) frasi.push(`${uso.join(", ")}${a.km ? `: ${a.km > 70000 ? "entro" : "ben sotto"} la soglia massima di 70/80.000 km prevista per il programma SecondLife` : ""}.`);

  const look = [];
  if (ok(a.colore_esterno)) look.push(`carrozzeria ${bello(a.colore_esterno)}`);
  const interni = (a.colore_interno || "").split(",").map((s) => s.trim()).filter(ok);
  if (interni.length) look.push(`interni ${bello(interni[interni.length - 1])}`);
  if (look.length) frasi.push(`Si presenta con ${look.join(" e ")}.`);

  const top = (a.optional || []).filter((o) => OPTIONAL_TOP.test(o)).slice(0, 5);
  if (top.length) frasi.push(`Tra le dotazioni di serie e optional: ${top.join(", ").toLowerCase()}${(a.optional || []).length > top.length ? ` e altri ${(a.optional || []).length - top.length} equipaggiamenti elencati più sotto` : ""}.`);
  else if ((a.optional || []).length) frasi.push(`La scheda riporta ${(a.optional || []).length} equipaggiamenti elencati più sotto.`);

  const extra = [];
  if (a.co2) extra.push(`emissioni dichiarate di ${a.co2} g/km di CO₂`);
  if (a.neopatentati === "SI") extra.push("guidabile dai neopatentati");
  if (a.neopatentati === "NO") extra.push("non adatta ai neopatentati");
  if (extra.length) frasi.push(`${extra.join(", ")[0].toUpperCase()}${extra.join(", ").slice(1)}.`);

  frasi.push(
    a.prezzo
      ? `Il prezzo è di ${eur(a.prezzo)} chiavi in mano, IVA esposta${a.esempio_quotazione ? `; esempio di quotazione: ${a.esempio_quotazione}` : ""}. Lo stock si aggiorna ogni ora: compila il modulo o scrivici su WhatsApp per bloccarla.`
      : "La quotazione è su richiesta: compila il modulo o scrivici su WhatsApp e un consulente ti risponde con disponibilità, canone e condizioni. Lo stock si aggiorna ogni ora e le auto assegnate escono subito dal sito."
  );
  return frasi.join(" ");
};
